/**
 * Permission/Role Service
 */
import { getApiClient } from '../apiClient';
import { PERMISSION_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetRolesResponse,
  GetRolesParams,
  GetRoleResponse,
  CreateRolePayload,
  CreateRoleResponse,
  UpdateRolePayload,
  UpdateRoleResponse,
  DeleteRoleResponse,
} from '../types/permission.types';

export const permissionService = {
  /**
   * Get all roles with pagination and search
   */
  getRoles: (params?: GetRolesParams): Promise<GetRolesResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) {
      queryParams.append('page', String(params.page));
    }
    if (params?.limit) {
      queryParams.append('limit', String(params.limit));
    }
    if (params?.offset) {
      queryParams.append('offset', String(params.offset));
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    const url = queryParams.toString()
      ? `${PERMISSION_ENDPOINTS.getRoles}?${queryParams.toString()}`
      : PERMISSION_ENDPOINTS.getRoles;
    return getApiClient().get(url);
  },

  /**
   * Get single role by ID
   */
  getRole: (id: string): Promise<GetRoleResponse> => {
    const url = replacePathParams(PERMISSION_ENDPOINTS.getRole, { id });
    return getApiClient().get(url);
  },

  /**
   * Create role
   */
  createRole: (body: CreateRolePayload): Promise<CreateRoleResponse> => {
    return getApiClient().post(PERMISSION_ENDPOINTS.createRole, body);
  },

  /**
   * Update role
   */
  updateRole: (id: string, body: UpdateRolePayload): Promise<UpdateRoleResponse> => {
    const url = replacePathParams(PERMISSION_ENDPOINTS.updateRole, { id });
    return getApiClient().put(url, body);
  },

  /**
   * Delete role
   */
  deleteRole: (id: string): Promise<DeleteRoleResponse> => {
    const url = replacePathParams(PERMISSION_ENDPOINTS.deleteRole, { id });
    return getApiClient().delete(url);
  },
};

